import type {
  CardBodyProps,
  CardProps} from '@chakra-ui/react'
import {
  Card,
  CardBody,
  CardFooter
} from '@chakra-ui/react'
import type { ReactNode } from 'react'
import { forwardRef } from 'react'

import type { FormSectionHeaderProps } from '@/containers/forms/FormSectionHeader'

import { SectionHeader } from './SectionHeader'

export interface SectionProps extends CardProps {
  sectionTitle?: string | ReactNode
  bodyProps?: CardBodyProps
  footer?: ReactNode
  wide?: boolean
  cardHeaderProps?: FormSectionHeaderProps
}

export const Section = forwardRef(
  (
    {
      children,
      sectionTitle,
      bodyProps,
      footer,
      wide = false,
      cardHeaderProps,
      ...rest
    }: SectionProps,
    ref,
  ) => {
    const { sx } = bodyProps || {}

    return (
      <Card ref={ref} overflow="hidden" {...rest}>
        {sectionTitle && <SectionHeader {...cardHeaderProps}>{sectionTitle}</SectionHeader>}

        <CardBody
          sx={{
            px: { md: 8, lg: wide ? 8 : 24 },
            pb: { base: 8, md: wide ? 8 : 24 },
            '&:empty': {
              display: 'none',
            },
            ...sx,
          }}
        >
          {children}
        </CardBody>

        {footer && <CardFooter>{footer}</CardFooter>}
      </Card>
    )
  },
)
